import { Component } from '@angular/core';
import { AbstractControl, AbstractControlOptions, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Constants } from 'src/app/shared/constants';
import { LocalizationService } from 'src/app/shared/localization/localization.service';
import { LocalDataService } from 'src/app/shared/services/local-data.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { LoginService } from '../login.service';
import {AppConfigService} from 'src/app/shared/services/app-config/app-config.service';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})

export class ChangePasswordComponent {
  oldPassHide = true;
  newPassHide = true;
  cnfmPassHide = true;
  // At least 9 characters long, should include at least one capital letter and combination of alphanumeric & special characters
  public passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,}$/;

  constructor(
    public _dialogRef: MatDialogRef<ChangePasswordComponent>,
    private _formBuilder: FormBuilder,
    private _notificationService: NotificationService,
    private _localDataService: LocalDataService,
    private _loginSrvice: LoginService,
    private _localizationService: LocalizationService,
  ) {
    const loggedUser = this._localDataService.getLoginUserData();
    this.fillTheForm(loggedUser);
    _localDataService.selectedScreen = ['ChangePassword'];
    _localizationService.use(this._localDataService.selectedCountry + '_' + this._localDataService.selectedLanguage, [...Constants.Localization.commonAreas, ..._localDataService.selectedScreen]);
  }

  passwordMatchValidator: ValidatorFn = (
    control: AbstractControl
  ): ValidationErrors | null => {
    let newPass = control.get('newPassword');
    let confirmPass = control.get('confirmPassword');
    if(!confirmPass?.errors?.['required']) {
      if(newPass && confirmPass &&  newPass?.value != confirmPass?.value) {
        confirmPass.setErrors([{'passwordMismatch': true}]);
        return  { PasswordNoMatch: true };
      } else {
        confirmPass?.setErrors(null);
        return null;
      }
    } else {
      return null;
    }
  };

  changePasswordForm = this._formBuilder.group({
    emailId: [''],
    oldPassword: ['', Validators.required],
    newPassword: ['', [Validators.required, Validators.pattern(this.passwordPattern)]],
    confirmPassword: ['', [Validators.required]],
  },{validators: [this.passwordMatchValidator]} as AbstractControlOptions
  );

  submitChangePasswordForm() {
    let payload = this.payloadData();
    if (payload.oldPassword == payload.newPassword) {
      this._notificationService.errorMessage(("Old and new passwords cannot be same"), 'Error');
      return;
    }
    this._loginSrvice.changePassword(payload).subscribe({
      next: (result) => {
        if (result?.status == 200) {
          if (result?.body?.status == true) {
            if (result?.body?.mailStatus == true) {
              this._notificationService.successMessage(("Password changed successfully"), 'Success')
            } else {
              this._notificationService.successMessage(("Password changed successfully and Mail has not been delivered"), 'Success')
            }
            this._dialogRef.close();
          } else {
            this._notificationService.errorMessage(("Email Id is invalid"), 'Error')
          }
        } else {
          this._notificationService.errorMessage(
            ("Something went wrong"),
            'Error'
          );
        }
      }
    });
  }

  payloadData() {
    let payload: any = {};
    let rawFormData = this.changePasswordForm.getRawValue();
    payload.confirmPassword = rawFormData.confirmPassword;
    payload.emailId = rawFormData.emailId;
    payload.newPassword = rawFormData.newPassword;
    payload.oldPassword = rawFormData.oldPassword;
    payload.sendFrom = "user-chg-pwd";
    return payload;
  }

  fillTheForm(loggedUser: any) {
    if (loggedUser?.user?.emailId != null) {
      this.changePasswordForm.patchValue({
        emailId: loggedUser.user.emailId
      });
      this.changePasswordForm.controls.emailId.disable();
    }
  }
  onDialogCancel(): void {
    this._dialogRef.close();
  }

}
